import { createFileRoute } from '@tanstack/react-router'

import { ContractPartiesView } from '@/components/Internal/Finance/ContractPartiesView'

export const Route = createFileRoute('/internal/system/administration/parties')(
  {
    component: ContractPartiesView,
  },
)
